import React from 'react';

import {
    TripBoardsApolloProvider,
    TripBoardButton
} from '@homeaway/react-trip-board-button';

export default function TripBoardComponent(props) {
    return React.cloneElement(props.children, {
        tripboardComponent: {
            TripBoardsApolloProvider,
            TripBoardButton
        }
    });
}
